import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Iteration } from 'Component/others';

import { TextSemiBold } from 'UiKit/typography';
import { useScheduleGenerateState } from 'View/schedule-generate/state';

import styles from './styles.module.css';

const GenerateResultTab = () => {
  const { t } = useTranslation('schedule-generate');
  const { selectedTab, accounts, updateState } = useScheduleGenerateState();
  const options = accounts;
  return (
    <Box className={styles['generate-result__tab']}>
      <Iteration
        items={options}
        render={(opt) => {
          const isActive = selectedTab === opt.type;
          return (
            <Box
              key={opt.type}
              className={`${styles['generate-result__tab--item']} ${isActive && styles['generate-result__tab--item-actived']}`}
              onClick={() => updateState({ selectedTab: opt.type })}
            >
              <TextSemiBold className={styles['generate-result-tab__text-item']}>{opt.label}</TextSemiBold>
            </Box>
          );
        }}
      />
      {/* <Box
        className={`${styles['generate-result__tab--item']} ${selectedTab === 'recap' && styles['generate-result__tab--item-actived']}`}
        onClick={() => updateState({ selectedTab: 'recap' })}
      >
        <TextSemiBold className={styles['generate-result-tab__text-item']}>{t('dataSummary')}</TextSemiBold>
      </Box> */}
    </Box>
  );
};

export default GenerateResultTab;
